import * as R from 'ramda';
import { createReducer } from 'redux-act';
import { $all, $set, $toggle } from 'plow-js';
// common
import * as A from './actions';
// features
import {
  receivedSwitchBranchSuccess,
  getInitialBranchConfigsSuccess,
} from '../features/branch/actions';
// helpers/constants
import * as GC from '../constants';
//////////////////////////////////////////////////

const initialState = {
  submitLoading: false,
  documentTemplates: {},
  socketConnected: false,
  initialDataLoaded: false,
  existByScopeAndNames: {},
  initialDataLoading: false,
  initialConfigsLoaded: false,
  showDriverOnboardingTab: null,
  mailServiceIntegrationType: null,
  connectedToMailIntegrationEmails: {},
  connectionToMailIntegrationRequired: false,
  initialSplashScreenSetting: { isLoaded: false },
  // googleApiKey: 'AIzaSyB9Vj08tH1omYsW5k8GDWAY5PtfrE_OxAk',
};

const toggleSubmitLoading = (state) => $toggle('submitLoading', state);

const setGoogleApiKey = (state, googleApiKey) => (
  $set('googleApiKey', googleApiKey, state)
);

const initialDataLoadRequest = (state) => (
  $all(
    $set('initialDataLoaded', false),
    $set('initialDataLoading', true),
    state,
  )
);

const initialDataLoadFail = (state) => (
  $all(
    $set('initialDataLoaded', true),
    $set('initialDataLoading', false),
    state,
  )
);

const initialDataLoadSuccess = (state) => (
  $all(
    $set('initialDataLoaded', true),
    $set('initialDataLoading', false),
    state,
  )
);

const initialConfigsLoaded = (state) => (
  $set('initialConfigsLoaded', true, state)
);

const initialSplashScreenLoadFail = (state) => (
  $set('initialSplashScreenSetting', { isLoaded: true }, state)
);

const initialSplashScreenLoadSuccess = (state, data) => (
  $set('initialSplashScreenSetting', { ...data, isLoaded: true }, state)
);

const getDocumentTemplateSuccess = (state, data) => (
  $set('documentTemplates', R.groupBy(R.prop(GC.FIELD_PRINTABLE_SECTION), data), state)
);

const setConnectedToMailIntegrationEmails = (state, data) => (
  $set('connectedToMailIntegrationEmails', data, state)
);

const disconnectFromMailIntegrationSuccess = (state, email) => (
  $set('connectedToMailIntegrationEmails', R.dissoc(email, state.connectedToMailIntegrationEmails), state)
);

const setConnectionToMailIntegrationRequired = (state, data) => (
  $set('connectionToMailIntegrationRequired', data, state)
);

const setMailServiceIntegrationType = (state, data) => (
  $set('mailServiceIntegrationType', data, state)
);

const getShowDriverOnboardingTabSuccess = (state, showReportTab) => (
  $set('showDriverOnboardingTab', showReportTab, state)
);

const hideDriverOnboardingTabOnSwitchBrach = (state) => $set('showDriverOnboardingTab', null, state);

const setSocketConnection = (state, data) => $set('socketConnected', data, state);

const existByScopeAndNamesSuccess = (state, { value, nameToSave }) =>
  $set(`existByScopeAndNames.${nameToSave}`, value, state);

export const global = createReducer({
  [A.setGoogleApiKey]: setGoogleApiKey,
  [A.toggleSubmitLoading]: toggleSubmitLoading,
  [A.initialDataLoadFail]: initialDataLoadFail,
  [A.setSocketConnection]: setSocketConnection,
  [A.initialDataLoadRequest]: initialDataLoadRequest,
  [A.initialDataLoadSuccess]: initialDataLoadSuccess,
  [getInitialBranchConfigsSuccess]: initialConfigsLoaded,
  [A.getDocumentTemplateSuccess]: getDocumentTemplateSuccess,
  [A.initialSplashScreenLoadFail]: initialSplashScreenLoadFail,
  [A.existByScopeAndNamesSuccess]: existByScopeAndNamesSuccess,
  [A.setMailServiceIntegrationType]: setMailServiceIntegrationType,
  [A.initialSplashScreenLoadSuccess]: initialSplashScreenLoadSuccess,
  [receivedSwitchBranchSuccess]: hideDriverOnboardingTabOnSwitchBrach,
  [A.getShowDriverOnboardingTabSuccess]: getShowDriverOnboardingTabSuccess,
  [A.setConnectedToMailIntegrationEmails]: setConnectedToMailIntegrationEmails,
  [A.disconnectFromMailIntegrationSuccess]: disconnectFromMailIntegrationSuccess,
  [A.setConnectionToMailIntegrationRequired]: setConnectionToMailIntegrationRequired,
}, initialState);

export default global;
